import React from 'react';
import { Navigate } from 'react-router-dom';

const OpenPlayCommunityBoardPage = () => {
  return <Navigate to="/openplay/community" replace />;
};

export default OpenPlayCommunityBoardPage;
